import React, { FC } from 'react'
import './style.scss'

const dataList = [
	{
		svg: 'icon_list_1',
		title: 'Подача заявки онлайн',
	},
	{
		svg: 'icon_list_3',
		title: 'От 100 тыс. до 400 млн ₽',
	},
	{
		svg: 'icon_list_4',
		title: 'От 1 до 300 месяцев',
	},
]

export const IconListComponent: FC = () => {
	const className = {
		iconList: 'landing-credits_icon-list',
		icon: 'landing-credits_icon-list_icon',
		title: 'landing-credits_icon-list_title',
	}

	const renderItem = (item: typeof dataList[0]) => {
		const { svg, title } = item
		return (
			<div className={className.icon} key={svg}>
				<div className={className.icon}>
					<img src={`..//img/landing//${svg}.svg`} alt="" />
				</div>
				<div className={className.title}>{title}</div>
			</div>
		)
	}

	return (
		<div className={className.iconList}>
			{dataList.map((item): JSX.Element => renderItem(item))}
		</div>
	)
}
